(ns practitest.frontend.components2.dashboard.events
  (:require [practitest.frontend.components2.dashboard.helpers :as helpers]
            [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.common.re-frame :as rf-common]
            [practitest.frontend.events :as events]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.events.bar :as-alias bar]
            [practitest.frontend.components2.dashboard.helpers :as h]
            [re-frame.core :as rf]))

(defmulti transform
  (fn [evt _data] evt))

(defn transform-common
  [evt {:as   item
        :keys [id title data item-url x-values-map y-values-map status-colors]

        {:keys [colors cell-width
                legend-location
                percentage-mode
                remove-empty-values]} :highcharts-options}]
  (let [item {:chart/id                  id
              :chart/title               title
              :chart/data                data
              :chart/sub-title           (helpers/filters-title item)
              :chart/item-route          (helpers/parse-url item-url)
              :chart/x-values-map        x-values-map
              :chart/y-values-map        y-values-map
              :chart/user-colors         (helpers/parse-colors colors)
              :chart/status-colors       (into {} status-colors)
              :chart/percentage-mode     (helpers/str->bool percentage-mode)
              :chart/cell-width          (some-> cell-width str keyword)
              :chart/legend-location     (some-> legend-location str keyword)
              :chart/remove-empty-values (helpers/str->bool remove-empty-values)}]
    (merge item (transform evt item))))

(def load-chart
  {:merge-by  :chart/id
   :transform transform-common
   :db-path   [:dashboard-items]})

(def load-pie
  {:evt    ::load-pie-data
   :schema sc/PieChart})

(def load-bar
  {:evt    ::load-bar-data
   :schema sc/BarChart})

(def load-planned-vs-executed
  {:evt    ::load-planned-vs-executed-data
   :schema sc/PlannedVsExecutedChart})

(def load-stacked-bar
  {:evt    ::load-stacked-bar-data
   :schema sc/StackedBarChart})

(doseq [evt [load-pie load-bar load-planned-vs-executed load-stacked-bar]]
  (rf-common/reg-load-data-events (merge load-chart evt)))

(rf/reg-event-db
 ::toggle-legend-item
 (fn [db [_ id item]]
   (update-in db [:dashboard-items id :chart/toggle-legend item] (fnil not true))))

(rf/reg-event-fx
 ::navigate
 (fn [_ [_ {:chart/keys [item-route]} {:keys [url-params]}]]
   (when-let [url (h/url-for item-route url-params)]
     {::events/navigate url})))

(defmethod transform ::load-pie-data [_ {:chart/keys [data]}]
  {:chart/type          ::chart/pie
   :chart/legend-labels (conj (mapv first data) helpers/other-label)})

(defmethod transform ::load-bar-data [_ {:chart/keys [data]}]
  {:chart/type          ::chart/bar
   :chart/legend-labels (mapv :name (:series data))})

(defmethod transform ::load-planned-vs-executed-data [_ _]
  {:chart/type          ::chart/line
   :chart/legend-labels ["planned" "executed"]})

(defmethod transform ::load-stacked-bar-data [_ {:chart/keys [data] :as item}]
  (js/console.log "STACKED item:" (clj->js item))
  {:chart/type          ::chart/stacked-bar
   :chart/legend-labels (mapv :name (:series data))})
